import * as React from "react";
import Box from "@mui/material/Box";
import Typography from "@mui/material/Typography";
import Modal from "@mui/material/Modal";
import {  Grid, Link, InputLabel, Select, MenuItem, FormControl, Grid2 } from "@mui/material";
import './StateModal.scss'
import { useEffect, useRef } from "react";


const states = [
  { name: "Alabama", abbreviation: "AL" },
  { name: "Alaska", abbreviation: "AK" },
  { name: "Arizona", abbreviation: "AZ" },
  { name: "Arkansas", abbreviation: "AR" },
  { name: "California", abbreviation: "CA" },
  { name: "Colorado", abbreviation: "CO" },
  { name: "Connecticut", abbreviation: "CT" },
  { name: "Delaware", abbreviation: "DE" },
  { name: "Florida", abbreviation: "FL" },
  { name: "Georgia", abbreviation: "GA" },
  { name: "Hawaii", abbreviation: "HI" },
  { name: "Idaho", abbreviation: "ID" },
  { name: "Illinois", abbreviation: "IL" },
  { name: "Indiana", abbreviation: "IN" },
  { name: "Iowa", abbreviation: "IA" },
  { name: "Kansas", abbreviation: "KS" },
  { name: "Kentucky", abbreviation: "KY" },
  { name: "Louisiana", abbreviation: "LA" },
  { name: "Maine", abbreviation: "ME" },
  { name: "Maryland", abbreviation: "MD" },
  { name: "Massachusetts", abbreviation: "MA" },
  { name: "Michigan", abbreviation: "MI" },
  { name: "Minnesota", abbreviation: "MN" },
  { name: "Mississippi", abbreviation: "MS" },
  { name: "Missouri", abbreviation: "MO" },
  { name: "Montana", abbreviation: "MT" },
  { name: "Nebraska", abbreviation: "NE" },
  { name: "Nevada", abbreviation: "NV" },
  { name: "New Hampshire", abbreviation: "NH" },
  { name: "New Jersey", abbreviation: "NJ" },
  { name: "New Mexico", abbreviation: "NM" },
  { name: "New York", abbreviation: "NY" },
  { name: "North Carolina", abbreviation: "NC" },
  { name: "North Dakota", abbreviation: "ND" },
  { name: "Ohio", abbreviation: "OH" },
  { name: "Oklahoma", abbreviation: "OK" },
  { name: "Oregon", abbreviation: "OR" },
  { name: "Pennsylvania", abbreviation: "PA" },
  { name: "Rhode Island", abbreviation: "RI" },
  { name: "South Carolina", abbreviation: "SC" },
  { name: "South Dakota", abbreviation: "SD" },
  { name: "Tennessee", abbreviation: "TN" },
  { name: "Texas", abbreviation: "TX" },
  { name: "Utah", abbreviation: "UT" },
  { name: "Vermont", abbreviation: "VT" },
  { name: "Virginia", abbreviation: "VA" },
  { name: "Washington", abbreviation: "WA" },
  { name: "West Virginia", abbreviation: "WV" },
  { name: "Wisconsin", abbreviation: "WI" },
  { name: "Wyoming", abbreviation: "WY" },
];










export default function StateModal({ open, onClose }) {
  const modalRef = useRef(null); // Create a reference for the modal content
  const [selectedState, setSelectedState] = React.useState("");


  const handleStateChange = (event) => {
    const selectedAbbreviation = event.target.value;
    const url = `https://www.hud.gov/sites/dfiles/PIH/documents/PHA_Contact_Report_${selectedAbbreviation}.pdf`;

    console.log(url); // Logs the generated URL

    // Open the URL in a new tab
    window.open(url, "_blank");
  };

  if (!open) return null; // Don't render the modal if not open

  if (!open) return null; // Render nothing if `open` is false


 




  return (
    <div className="modal-overlay">
      <div className="modal-content" style={{ maxWidth: '700px', overflow: 'auto' }}>
      <div style={{  marginRight: 0, display: 'flex' , justifyContent:'right', marginTop:'-13px'}} >

<button onClick={onClose} >
X
</button>
</div>
      <div className="modal-header" style={{ textAlign: 'center' }}>
      <img
        src="https://storage.googleapis.com/download/storage/v1/b/g-green-backend-bucket-1/o/tbhafl%2Fr1.jpg?generation=1680193688409346&alt=media" // Replace with your image URL
        alt="Welcome"
        style={{ width: '100%', height: 'auto', borderRadius: '8px' }}
      />
      <h3 style={{ marginTop: '10px', fontSize: '30px', color: '#333' }}>
        What is a Housing Authority? 
      </h3>
      <h3 style={{ marginTop: '10px', fontSize: '16px', color: '#333', padding: '0 10px', textAlign: 'center' }}>
      A housing authority is a local or regional government agency responsible for overseeing <br/> the management and administration of affordable housing programs in a specific area. <br/> Their primary role is to provide safe, decent, and affordable housing options for low-income <br/> individuals and families. Housing authorities are tasked with administering public housing <br/> programs, distributing housing vouchers (like Section 8), and ensuring that housing policies <br/> align with federal and local regulations. They also often play a role in maintaining housing <br/> quality, conducting inspections, and offering resources to assist tenants in finding suitable <br/> housing. Overall, housing authorities help make homeownership or rental housing more <br/>accessible to those who might otherwise struggle with high housing costs.      </h3>
      <h3 style={{ marginTop: '10px', marginBottom: '15px' ,fontWeight: 800, fontSize: '20px', color: '#333' }}>
Select your state below to view your county's PHA Contact Info      </h3>
    </div>

        <form>
          {/* <label htmlFor="state">Select State:</label> */}
          <select id="state" name="state" defaultValue="" 
          style={{color:'black',
          textAlign:'center',
          textAlignLast:'center',
          padding:'8px',
          width:'100%'
          
          
          }} onChange={handleStateChange}>
            <option value="" disabled>
              -- Select a State --
            </option>
            {states.map((state) => (
              <option key={state.abbreviation} value={state.abbreviation}>
                {state.name}
              </option>
            ))}
          </select>
        </form>
           </div>
    </div>
  );
};